module.exports = __webpack_public_path__ + "static/CSS.3.svg-7da1f0bed7811a486e7cbc0a0e25b5ea.png";